import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

export default function UploadAdmin() {
  const [datasets, setDatasets] = useState([]);
  const [name,     setName]     = useState('');
  const [file,     setFile]     = useState(null);
  const [error,    setError]    = useState('');
  const [success,  setSuccess]  = useState('');
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const load = () => {
    axios.get('/api/datasets').then(r => setDatasets(r.data)).catch(console.error);
  };
  useEffect(() => { load(); }, []);

  const handleUpload = async e => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (!name.trim()) { setError('Dataset name is required'); return; }
    if (!file) { setError('Please select a JSON file'); return; }
    setUploading(true);
    const fd = new FormData();
    fd.append('name', name.trim());
    fd.append('file', file);
    try {
      await axios.post('/api/datasets', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setSuccess(`"${name}" uploaded successfully`);
      setName(''); setFile(null);
      if (fileRef.current) fileRef.current.value = '';
      load();
    } catch (err) {
      setError(err.response?.data?.message || 'Upload failed');
    } finally { setUploading(false); }
  };

  const handleDelete = async (id, dsName) => {
    if (!window.confirm(`Delete dataset "${dsName}"?`)) return;
    try { await axios.delete(`/api/datasets/${id}`); load(); }
    catch (err) { alert(err.response?.data?.message || 'Error'); }
  };

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: 14, fontWeight: 700, letterSpacing: '.05em', marginBottom: 20 }}>
        Upload Dataset
      </h2>

      <div className="card" style={{ marginBottom: 24 }}>
        <h3 style={{ fontFamily: 'Syne, sans-serif', fontSize: 12, fontWeight: 700, letterSpacing: '.06em', marginBottom: 14, color: 'var(--accent)' }}>
          UPLOAD JSON FILE
        </h3>
        <form onSubmit={handleUpload} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={{ fontSize: 9, color: 'var(--muted)', display: 'block', marginBottom: 5, letterSpacing: '.06em' }}>DATASET NAME</label>
            <input className="input" placeholder="e.g. Georgia Healthcare Pilot" value={name} onChange={e => setName(e.target.value)} style={{ maxWidth: 400 }} />
          </div>
          <div>
            <label style={{ fontSize: 9, color: 'var(--muted)', display: 'block', marginBottom: 5, letterSpacing: '.06em' }}>JSON FILE</label>
            <input ref={fileRef} type="file" accept=".json,application/json"
              onChange={e => setFile(e.target.files[0])}
              style={{ fontSize: 11, color: 'var(--text)', background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 12px', cursor: 'pointer', maxWidth: 400, display: 'block' }} />
            {file && <div style={{ fontSize: 10, color: 'var(--success)', marginTop: 5 }}>✓ {file.name} ({(file.size/1024).toFixed(1)} KB)</div>}
          </div>
          <div>
            <button className="btn btn-primary" type="submit" disabled={uploading}>
              {uploading ? 'Uploading…' : '⬆ Upload Dataset'}
            </button>
          </div>
        </form>
        {error   && <div className="error-msg"   style={{ marginTop: 10 }}>{error}</div>}
        {success && <div className="success-msg" style={{ marginTop: 10 }}>{success}</div>}
      </div>

      {/* Existing datasets */}
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontFamily: 'Syne, sans-serif', fontSize: 12, fontWeight: 700 }}>UPLOADED DATASETS</span>
          <span className="tag">{datasets.length}</span>
        </div>
        {datasets.length === 0 ? (
          <div style={{ padding: 20, color: 'var(--muted)', fontSize: 12 }}>No datasets yet.</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: 'var(--row-overlay)' }}>
                {['Name','File','Uploaded',''].map(h => (
                  <th key={h} style={{ padding: '8px 16px', textAlign: 'left', fontSize: 9, color: 'var(--muted)', letterSpacing: '.06em', fontWeight: 700, borderBottom: '1px solid var(--border)' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {datasets.map(ds => (
                <tr key={ds._id} style={{ borderBottom: '1px solid var(--border)' }}>
                  <td style={{ padding: '10px 16px', fontWeight: 600, color: 'var(--accent)' }}>{ds.name}</td>
                  <td style={{ padding: '10px 16px', color: 'var(--muted)', fontSize: 10 }}>{ds.originalName}</td>
                  <td style={{ padding: '10px 16px', color: 'var(--muted)', fontSize: 10 }}>{new Date(ds.createdAt).toLocaleDateString()}</td>
                  <td style={{ padding: '10px 16px' }}>
                    <button className="btn btn-danger" onClick={() => handleDelete(ds._id, ds.name)} style={{ fontSize: 10, padding: '4px 10px' }}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
